module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner-wayo@2x-5737dca7a1eeff0d06f0490d429cedc3.webp";